var _style, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyHalf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004282;}\n\t.st1{clip-path:url(#SVGID_00000058555236628731572850000000688829040201623449_);fill:#006BB7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.2,0.6C12.5,0.6,0.6,12.5,0.6,27.2s11.9,26.6,26.6,26.6s26.6-11.9,26.6-26.6S41.9,0.6,27.2,0.6z M24.4,24.5 c0.7,0.7,1.7,1.1,2.7,1.2h0.1c4,0,7.3,3.3,7.3,7.3c0,3.4-2.4,6.3-5.6,7.1v3.1h-3.4v-3.1c-1.3-0.3-2.5-1-3.5-1.9 c-1.2-1.2-2-2.8-2.1-4.5l-0.1-1h3.3l0.1,0.8c0.1,0.9,0.5,1.7,1.1,2.4c0.8,0.8,1.8,1.2,2.8,1.2c2.2,0,4-1.8,4-4c0-2.2-1.7-4-3.9-4 h-0.1c-2,0-3.8-0.8-5.2-2.1c-1.4-1.4-2.1-3.2-2.1-5.2c0-3.4,2.4-6.3,5.6-7.1v-3.3h3.4v3.3c3,0.7,5.3,3.3,5.6,6.5l0.1,0.9h-3.2 l-0.1-0.8c-0.2-2.1-2-3.6-4-3.6c-2.2,0-4,1.8-4,4C23.2,22.7,23.6,23.7,24.4,24.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 27.2,
    height: 55
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000071532473464428714210000009953182691001526934_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000071532473464428714210000009953182691001526934_)",
      fill: "#006BB7"
    },
    d: "M27.2,0.6 C12.5,0.6,0.6,12.5,0.6,27.2s11.9,26.6,26.6,26.6s26.6-11.9,26.6-26.6S41.9,0.6,27.2,0.6z M24.4,24.5c0.7,0.7,1.7,1.1,2.7,1.2h0.1 c4,0,7.3,3.3,7.3,7.3c0,3.4-2.4,6.3-5.6,7.1v3.1h-3.4v-3.1c-1.3-0.3-2.5-1-3.5-1.9c-1.2-1.2-2-2.8-2.1-4.5l-0.1-1h3.3l0.1,0.8 c0.1,0.9,0.5,1.7,1.1,2.4c0.8,0.8,1.8,1.2,2.8,1.2c2.2,0,4-1.8,4-4c0-2.2-1.7-4-3.9-4h-0.1c-2,0-3.8-0.8-5.2-2.1 c-1.4-1.4-2.1-3.2-2.1-5.2c0-3.4,2.4-6.3,5.6-7.1v-3.3h3.4v3.3c3,0.7,5.3,3.3,5.6,6.5l0.1,0.9h-3.2l-0.1-0.8c-0.2-2.1-2-3.6-4-3.6 c-2.2,0-4,1.8-4,4C23.2,22.7,23.6,23.7,24.4,24.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyHalf);
export default __webpack_public_path__ + "static/media/money-half.07bb11ff621a7df2b8d3267170b311ed.svg";
export { ForwardRef as ReactComponent };